import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'code-step',
  templateUrl: './code-step.component.html'
})
export class CodeStepComponent {
  @Input()
  public verificationCodeForm: FormArray;

  constructor() { }
}
